import React from 'react';

import TopLinksSearch from './top-links-search/TopLinksSearch';
import TopLinksBlock from './TopLinksBlock';

import SupportSVG from '../../icons/SupportSVG';
import EmailSVG from '../../icons/EmailSVG';
import CartSVG from '../../icons/CartSVG';
import MysasktelSVG from '../../icons/MysasktelSVG';

import './TopLinks.css';

function NavBar(props) {
  const loggedIn = true;
  return (
    <div>
      <nav aria-label="Primary navigation" className="p-0 m-0 h-60 bg-almost-black flex flex-row xl:block desktop">
        <div className="w-full px-45 mx-auto my-0 max-w-w-7xl flex flex-row z-10">
          <ul className="flex flex-row h-60 border-charcoal border-b-0">
            <li className="font-museo font-w-600 bg-white text-almost-black m-0 h-full pt-0 px-0 w-100 text-14 leading-17 flex justify-center items-center">
              <a href="https://www.sasktel.com">Personal</a>
            </li>
            <li className="font-museo font-w-600 bg-almost-black text-middle-grey m-0 h-full px-0 w-100 text-14 leading-17 flex justify-center items-center">
              <a href="https://sasktel.com/wps/wcm/connect/content/home/for-business">Business</a>
            </li>
          </ul>
          <div className="w-full h-60 flex flex-row justify-end">
            <TopLinksSearch isSearchToggled={props.isSearchToggled} isMobile={false} />
            <ul className="links-container h-60 m-0 font-museo font-w-300 font-w-300 text-17 leading-22 flex flex-row">
              <TopLinksBlock
                label="Support"
                listClasses="p-15 h-55 w-100 bg-almost-black"
                imgClasses="w-11 h-16"
                imgSpacingClasses="mt-4 mb-15 mr-5"
                labelClasses="ml-2 mt-2 text-10 leading-10"
                href="https://support.sasktel.com/app/home"
              >
                <SupportSVG fill="#aaa" width="33" height="48" viewbox="0 0 1024 1024" />
              </TopLinksBlock>
              <TopLinksBlock
                label="Sasktel.net"
                listClasses="p-15 h-55 w-100 bg-almost-black"
                imgClasses="w-15 h-11"
                imgSpacingClasses="mt-14 mb-10 mr-2"
                labelClasses="mt-2 ml-2 text-10 leading-10"
                href="https://webmail.sasktel.net/magnum/themes/branding/2370/index.html"
              >
                <EmailSVG fill="#aaa" width="30" height="30" viewbox="0 0 1024 1024" />
              </TopLinksBlock>
              <TopLinksBlock
                label="Cart"
                listClasses="p-15 h-55 w-100 bg-almost-black"
                imgClasses="w-16 h-14"
                imgSpacingClasses="mt-13 mb-10 mr-5"
                labelClasses="ml-2 text-10 leading-10"
                href="https://sasktel.com/store/cart-summary"
              >
                <CartSVG fill="#aaa" width="29" height="29" viewbox="0 0 1024 1024" />
              </TopLinksBlock>
              {loggedIn ? (
                <TopLinksBlock
                  label="Log in"
                  listClasses="h-70 flex-col w-130 bg-almost-black"
                  imgClasses="w-100 h-20"
                  imgSpacingClasses="mx-15 mt-16 mb-1"
                  labelClasses="mr-5 text-10 leading-10"
                  href="https://sasktel.com/wps/myportal/sasktel/mysasktel/"
                >
                  <MysasktelSVG fill="#aaa" width="100" height="100" viewbox="0 0 1024 1024" />
                </TopLinksBlock>
              ) : (
                <TopLinksBlock
                  label="Log out"
                  listClasses="h-70 flex-col w-130 bg-almost-black"
                  imgClasses="w-100 h-20"
                  imgSpacingClasses="mx-15 mt-16 mb-1"
                  labelClasses="text-10 leading-10"
                  href="https://sasktel.com/oamsso/logout.html"
                >
                  <MysasktelSVG fill="#aaa" width="100" height="100" viewbox="0 0 1024 1024" />
                </TopLinksBlock>
              )}
            </ul>
          </div>
        </div>
      </nav>
      <div className="mobile">
        <TopLinksSearch isSearchToggled={props.isSearchToggled} isMobile={true} />
        {props.isHamburgerToggled && (
          <div className="h-screen">
            <nav aria-label="Primary navigation" className="p-0 m-0 h-60 bg-almost-black flex flex-row flex-shrink">
              <div className="w-full mx-auto my-0 max-w-w-7xl flex flex-col z-10">
                <ul className="flex flex-row h-65 border-charcoal border-b-1">
                  <li className="font-museo font-w-600 bg-white text-almost-black m-0 h-full pt-5 px-0 w-1/2 text-14 leading-17 flex justify-center border-primary border-b-5 items-center">
                    <a href="https://www.sasktel.com">Personal</a>
                  </li>
                  <li className="font-museo font-w-600 bg-white xl:bg-almost-black text-almost-black m-0 h-full px-0 w-1/2 text-14 leading-17 flex justify-center items-center">
                    <a href="https://sasktel.com/wps/wcm/connect/content/home/for-business">Business</a>
                  </li>
                </ul>
                <div className="w-full flex flex-col justify-end">
                  <ul className="links-container m-0 font-museo font-w-300 flex flex-col">
                    <TopLinksBlock
                      label="Support"
                      listClasses="p-15 md:px-30 lg:px-45 h-55 w-full bg-almost-black"
                      imgClasses="w-13 h-18"
                      imgSpacingClasses="pl-2 mb-15 mr-11"
                      labelClasses="mt-2 ml-2 text-12 leading-12"
                      href="https://support.sasktel.com/app/home"
                    >
                      <SupportSVG fill="#aaa" width="36" height="48" viewbox="0 0 1024 1024" />
                    </TopLinksBlock>
                    <TopLinksBlock
                      label="Sasktel.net"
                      listClasses="p-15 md:px-30 lg:px-45 h-55 w-full bg-almost-black"
                      imgClasses="w-18 h-13"
                      imgSpacingClasses="mr-10 xl:mt-2"
                      labelClasses="mt-2 ml-2 text-12 leading-12"
                      href="https://webmail.sasktel.net/magnum/themes/branding/2370/index.html"
                    >
                      <EmailSVG fill="#aaa" width="36" height="36" viewbox="0 0 1024 1024" />
                    </TopLinksBlock>
                    <TopLinksBlock
                      label="Cart"
                      listClasses="p-15 md:px-30 lg:px-45 h-55 w-full bg-almost-black"
                      imgClasses="w-18 h-16"
                      imgSpacingClasses="mr-10"
                      labelClasses="ml-2 text-12 leading-12"
                      href="https://sasktel.com/store/cart-summary"
                    >
                      <CartSVG fill="#aaa" width="35" height="35" viewbox="0 0 1024 1024" />
                    </TopLinksBlock>
                    {loggedIn ? (
                      <TopLinksBlock
                        label="Log in"
                        listClasses="p-20 pb-10 h-70 flex-col bg-almost-black"
                        imgClasses="w-100 h-20"
                        imgSpacingClasses="mx-15 mt-4 mb-1"
                        labelClasses="text-10 leading-10"
                        href="https://sasktel.com/wps/myportal/sasktel/mysasktel/"
                      >
                        <MysasktelSVG fill="#aaa" width="100" height="100" viewbox="0 0 1024 1024" />
                      </TopLinksBlock>
                    ) : (
                      <TopLinksBlock
                        label="Log out"
                        listClasses="p-20 pb-10 h-70 flex-col bg-almost-black"
                        imgClasses="w-100 h-20"
                        imgSpacingClasses="mx-15 mt-4 mb-1"
                        labelClasses="text-10 leading-10"
                        href="https://sasktel.com/oamsso/logout.html"
                      >
                        <MysasktelSVG fill="#aaa" width="100" height="100" viewbox="0 0 1024 1024" />
                      </TopLinksBlock>
                    )}
                  </ul>
                </div>
              </div>
            </nav>
            <div className="flex-grow" />
          </div>
        )}
      </div>
    </div>
  );
}

export default NavBar;
